import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import axios from "axios";

const Tabla11 = (props) => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleUpload = async () => {
    if (!file) {
      alert("Por favor, selecciona un archivo CSV");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    setLoading(true);
    try {
      const response = await axios.post(
        "https://suadesarrollo.azurewebsites.net/api/CreaTablaNumeral/" +
          props.idSolicitud,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      alert("Archivo subido correctamente");
      console.log(response.data);
    } catch (error) {
      console.error("Error al subir el archivo", error);
      alert("Hubo un error al subir el archivo");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h6 className="m-0 font-weight-bold text-primary">
        11. CALIFICACIONES INFORME EVALUADOR
      </h6>
      <Form>
        <Form.Group controlId="formFile" className="mb-3">
          <Form.Label>Selecciona un archivo CSV</Form.Label>
          <Form.Control type="file" accept=".csv" onChange={handleFileChange} />
        </Form.Group>
        <Button variant="primary" onClick={handleUpload} disabled={loading}>
          {loading ? "Subiendo..." : "Subir Archivo"}
        </Button>
      </Form>
    </div>
  );
};

export default Tabla11;
